import Pill from './Pill'

export default Pill
